import { render, staticRenderFns } from "./CreatorStatsPage.vue?vue&type=template&id=4bf2d6d6&"
import script from "./CreatorStatsPage.vue?vue&type=script&lang=js&"
export * from "./CreatorStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports